import {useStores} from "~/stores";
import {toCurrencyWithP} from "~/components/currency-component/CurrencyClasses";

/** Compact money in the workspace currency (e.g. €8.4M), for chart labels and grid values. */
export function useMoneyFormat(): (v: number) => string {
    const {p} = useStores();
    return v => toCurrencyWithP(v, p.currencyFormat, p.currencySymbol, undefined, 2);
}
